import { render } from "./EmailProviders.vue?vue&type=template&id=0334f08d"
import script from "./EmailProviders.vue?vue&type=script&lang=js"
export * from "./EmailProviders.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/views/project/EmailProviders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0334f08d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0334f08d', __exports__)) {
    api.reload('0334f08d', __exports__)
  }
  
  module.hot.accept("./EmailProviders.vue?vue&type=template&id=0334f08d", () => {
    api.rerender('0334f08d', render)
  })

}


export default __exports__